module.exports = __webpack_public_path__ + "static/media/ClaireHutchinson.f935da8e.jpg";